import GallerySimple from "../blocks/gallery-simple";
import Gallery from "../blocks/gallery";
import GalleryVideo from "../blocks/gallery-video";

const templateServices = {
  init() {
    new GallerySimple(".gallery-simple");
    new Gallery(".gallery");
    new GalleryVideo(".gallery-video");
  },
};
export default templateServices;
